import { Image, Link } from "@/components/Elements";
import useToast from "@/hooks/useToast";
import { RouteConstant } from "@/routes/routeConstant";
import { RootState } from "@/store/reducers";
import { useSelector } from "react-redux";

export const Header = () => {
  const maxAdvertCount = useSelector(
    (state: RootState) => state.login.userDetail.maxAdvertCount
  );
  const advertCount = useSelector(
    (state: RootState) => state.advert.advertList.length
  );
  const { showError } = useToast();

  const handleCreateAdvert = (e: any) => {
    if (maxAdvertCount && maxAdvertCount <= advertCount) {
      e.preventDefault();
      showError("You have reached the maximum limit. Please contact admin");
    }
  };

  return (
    <div className="flex justify-between items-center p-[10px] pb-0 bg-[#ffffff] min-w-[80px]">
      <Link
        className="w-[22px] h-[22px]"
        to={RouteConstant.CreateAdvert}
        title="Create new advert"
        onClick={handleCreateAdvert}
      >
        <Image src="plus.png" className="w-full h-full" />
      </Link>
      <Link
        className="w-[22px] h-[22px]"
        to={RouteConstant.Profile}
        title="View Profile"
      >
        <Image src="user1.png" className="w-full h-full" />
      </Link>
    </div>
  );
};
